import React, { createContext, useContext, useState } from "react";

// Create the context
const TenantContext = createContext(null);

// Custom hook to use the context
export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error("useTenant must be used within a TenantProvider");
  }
  return context;
};

// Provider component
export const TenantProvider = ({ children }) => {
  const [tenant, setTenant] = useState(() => {
    try {
      const raw = sessionStorage.getItem("selected_tenant");
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (
        parsed &&
        parsed.id &&
        parsed.name &&
        parsed.domain &&
        parsed.role
      ) {
        return parsed;
      }
      return null;
    } catch {
      return null;
    }
  });


  function getTenant() {
    if (tenant && tenant.id && tenant.name && tenant.domain && tenant.role) {
      return tenant;
    }
    return null;
  }

  function selectTenant(tenant) {
    if (tenant && tenant.id && tenant.name && tenant.domain && tenant.role) {
      setTenant(tenant);
      sessionStorage.setItem("selected_tenant", JSON.stringify(tenant));
    } else {
      console.error("Invalid tenant object:", tenant);
    }
  }

  function clearTenant() {
    setTenant(null);
    sessionStorage.removeItem("selected_tenant");
  }

  return (
    <TenantContext.Provider value={{ getTenant, selectTenant, clearTenant }}>
      {children}
    </TenantContext.Provider>
  );
};
